import styled from "styled-components";
import Link from "next/link";

export const Container = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;

export const Content = styled.main`
  flex: 1;
  padding: 6rem 2rem 3rem;
  background: #f8f9fa;
`;

export const ContentWrapper = styled.div`
  max-width: 900px;
  margin: 0 auto;
`;

export const Title = styled.h1`
  font-size: 3rem;
  font-weight: 800;
  color: #2c3e50;
  margin-bottom: 1.5rem;
  font-family: var(--font-poppins), sans-serif;
  text-align: center;

  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;

export const Subtitle = styled.p`
  font-size: 1.2rem;
  line-height: 1.8;
  color: #4a5568;
  text-align: center;
  margin-bottom: 3rem;
`;

export const ContactGrid = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 3rem;
`;

export const ContactCard = styled.div`
  background: white;
  border-radius: 12px;
  padding: 2rem;
  text-align: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  transition: transform 0.3s ease, box-shadow 0.3s ease;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.12);
  }
`;

export const CardIcon = styled.div`
  font-size: 3rem;
  margin-bottom: 1rem;
`;

export const CardTitle = styled.h3`
  font-size: 1.3rem;
  font-weight: 700;
  color: #2c3e50;
  margin-bottom: 0.75rem;
`;

export const CardText = styled.p`
  font-size: 1rem;
  line-height: 1.6;
  color: #4a5568;
  margin-bottom: 0.5rem;
`;

export const CardLink = styled.a`
  color: #c8553d;
  text-decoration: none;
  font-weight: 600;
  transition: opacity 0.3s ease;

  &:hover {
    opacity: 0.8;
    text-decoration: underline;
  }
`;

export const FormSection = styled.div`
  background: white;
  border-radius: 16px;
  padding: 3rem;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);

  @media (max-width: 768px) {
    padding: 2rem 1.5rem;
  }
`;

export const FormTitle = styled.h2`
  font-size: 2rem;
  font-weight: 700;
  color: #2c3e50;
  margin-bottom: 1.5rem;
  text-align: center;
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;

export const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const Label = styled.label`
  font-size: 1rem;
  font-weight: 600;
  color: #2c3e50;
`;

export const Input = styled.input`
  padding: 0.875rem 1rem;
  border: 2px solid #e5e7eb;
  border-radius: 8px;
  font-size: 1rem;
  font-family: var(--font-poppins), sans-serif;
  transition: border-color 0.3s ease;

  &:focus {
    outline: none;
    border-color: #c8553d;
  }
`;

export const TextArea = styled.textarea`
  padding: 0.875rem 1rem;
  border: 2px solid #e5e7eb;
  border-radius: 8px;
  font-size: 1rem;
  font-family: var(--font-poppins), sans-serif;
  min-height: 150px;
  resize: vertical;
  transition: border-color 0.3s ease;

  &:focus {
    outline: none;
    border-color: #c8553d;
  }
`;

export const Select = styled.select`
  padding: 0.875rem 1rem;
  border: 2px solid #e5e7eb;
  border-radius: 8px;
  font-size: 1rem;
  font-family: var(--font-poppins), sans-serif;
  transition: border-color 0.3s ease;
  background: white;

  &:focus {
    outline: none;
    border-color: #c8553d;
  }
`;

export const SubmitButton = styled.button`
  background: linear-gradient(135deg, #c8553d 0%, #f2853b 100%);
  color: white;
  padding: 1rem 2rem;
  border: none;
  border-radius: 50px;
  font-size: 1.1rem;
  font-weight: 700;
  font-family: var(--font-poppins), sans-serif;
  cursor: pointer;
  transition: transform 0.3s ease, box-shadow 0.3s ease;

  &:hover:not(:disabled) {
    transform: translateY(-2px);
    box-shadow: 0 8px 20px rgba(200, 85, 61, 0.3);
  }

  &:active:not(:disabled) {
    transform: translateY(0);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const StatusMessage = styled.div<{ $type: "success" | "error" }>`
  padding: 1rem 1.5rem;
  border-radius: 8px;
  margin-bottom: 1.5rem;
  font-size: 1rem;
  font-weight: 500;
  background: ${(props) => (props.$type === "success" ? "#d4edda" : "#f8d7da")};
  color: ${(props) => (props.$type === "success" ? "#155724" : "#721c24")};
  border: 1px solid
    ${(props) => (props.$type === "success" ? "#c3e6cb" : "#f5c6cb")};
`;

export const FAQLink = styled(Link)`
  display: block;
  text-align: center;
  margin-top: 2rem;
  color: #4a5568;
  font-size: 1rem;

  span {
    color: #c8553d;
    font-weight: 600;
    text-decoration: underline;
  }
`;
